import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { useContext } from "react";
import TurnosConvencionesContext from "../../../../store/modal-convenciones-context";

const ModalConvenciones = ({ modalState }) => {
    const { convenciones } = useContext(TurnosConvencionesContext);

    return (
        <Modal
            size="lg"
            centered={true}
            id="modalConvenciones"
            isOpen={modalState.show}
            title="Ver Convenciones de Turnos"
        >
            <ModalHeader className="bg-secondary text-white text-bold">
                Convenciones
            </ModalHeader>
            <ModalBody>
                <table id="tablaConvenciones" className="table">
                    <thead>
                        <tr>
                            <th>Sigla</th>
                            <th>Horas</th>
                            <th>Horario</th>
                            <th>Inicio Receso</th>
                            <th>Fin Receso</th>
                            <th>Comentario</th>
                        </tr>
                    </thead>
                    <tbody id="bodyTablaConvenciones">
                        {convenciones.map((convencion) => {
                            return (
                                <tr
                                    key={convencion.sigla}
                                    style={{
                                        backgroundColor: convencion.color,
                                    }}
                                >
                                    <th>{convencion.sigla}</th>
                                    <th>{convencion.horas}</th>
                                    <th>{`${convencion.inicio} - ${convencion.fin}`}</th>
                                    <th>{convencion.inicio_receso}</th>
                                    <th>{convencion.fin_receso}</th>
                                    <th>{convencion.nombre}</th>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </ModalBody>
            <ModalFooter>
                <Button
                    color="secondary"
                    key="close"
                    onClick={() => modalState.close()}
                >
                    <i className="fas fa-times mr-2"></i>
                    Cerrar
                </Button>
            </ModalFooter>
        </Modal>
    );
};

ModalConvenciones.propTypes = {
    modalState: PropTypes.object
}

export default ModalConvenciones;
